'use strict'

import { EntityActions } from '../common/base/entity'
// import {EntityComponent} from '../entity'

export class CaseFieldAction extends EntityActions {
	constructor(options) {
		super(options)
	}

	preActionsHooks({ actionName, item, actionMeta }) {
		if (!item || Object.keys(item).length === 0) return
		if (item && actionName == 'editItem') {
			if(item.fieldProperties.required === 1) item.fieldProperties.required = true
			if(item.fieldProperties.required === 0) item.fieldProperties.required = false
			if (!item.deletedSeq) item.deletedSeq = 0
			return item
		} else {
			return item
		}
	}

	postActionsHooks({ actionName, item, tenantId }) {
		switch (actionName) {
			case 'getAll':
				let items =
					item &&
					item.map(i => {
						i = Object.assign({}, i, i.fieldProperties)
						i.fieldProperties_sectionName = i.sectionName || '-'
						i.fieldProperties_type = i.type || '-'
						return i
					})
				return items
			case 'getOne':
				// item = Object.assign({}, item, item.properties);
				// item.emailAddress = item.properties && item.properties.emailAddress;
				return item
			default:
				return item
		}
	}
}
